import { vn_app_zone_notification } from "./vn_app_zone_notification";
import { vnModule_knockoutJS } from "./vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../XMLHttpRequestHandler/XMLHttpRequestHandler";
import { rolesEdit_template } from "../vnKnockoutJsTemplates/rolesEdit_template";
import { XMLHttpRequestHandler_requestType } from "../XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
export class roles_edit extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this._isLeavePageWarningNeeded = true;
    }
    getModuleName() {
        return "roles_edit";
    }
    buildContent() {
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        if (zoneHeader) {
            let loadedModule = zoneHeader.loadedModule;
            loadedModule.setHeaderTitle("Role Edit");
        }
        this.rolesEditTemplate = new rolesEdit_template("rolesEdit_template", this.viewModel, this);
        return [this.rolesEditTemplate.build()];
    }
    //
    // fill the page at first load.
    fillPage() {
        this.getFormData();
    }
    saveEditRole() {
        this.save();
    }
    cancelForm() {
        this.cancelEditRole();
    }
    cancelEditRole() {
        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Role action canceled !");
        page.redirect('/roles');
    }
    // Getting role data from server.
    getFormData(takeover = false) {
        this.loadingIn(this.rolesEditTemplate.builtTemplate.children.namedItem("view-results"));
        let id = this.getVnAppZone().app.params.id;
        if (!isNaN(id) && this.getVnAppZone().app.params.id != 'undefined') {
            this.rolesEditTemplate.getTemplateViewModel().idRole(id);
        }
        else {
            id = 0;
        }
        console.log(id);
        this.XHRHdl = new XMLHttpRequestHandler(`/api/roles/get/${id}/`, [['takeover', (takeover) ? '1' : '0'], ['mode', 'edit']], this);
        this.XHRHdl.onReadyStateFunction = this.onGetRoleDataReturn;
        this.XHRHdl.execute();
    }
    // Handling response data.
    onGetRoleDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.viewRole(responseParsed);
                obj.loadingOut(obj.rolesEditTemplate.builtTemplate.children.namedItem("view-results"));
            });
        };
    }
    viewRole(role) {
        this.rolesEditTemplate.setRole(role);
    }
    save() {
        this.loadingIn(this.rolesEditTemplate.builtTemplate.children.namedItem("view-results"));
        let formReq_url = '/api/roles/save/';
        let formReq_params = [];
        let subViewModel = JSON.parse(ko.toJSON(this.rolesEditTemplate.getRole()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        let XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPostRoleData;
        XHRHdl.execute();
    }
    onPostRoleData(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Role saved successfully!");
                obj.loadingOut(obj.rolesEditTemplate.builtTemplate.children.namedItem("view-results"));
                page.redirect('/roles');
            });
            if (req.request.status != 200) {
                obj.unprepareAdsSetupForBackend(obj.adUnits_template.getTemplateViewModel().role());
            }
        };
    }
    //
    // Fix sections for further editing.
    unprepareAdsSetupForBackend(role) {
        for (let section of role.sections) {
            this.rolesEditTemplate.addInfoButton(section, section['id'], section['section']['description'] || '');
        }
    }
    /** @inheritDoc */
    confirmationModalOnClickConfirm(context, data) {
        this.getFormData(true);
    }
    /** @inheritDoc */
    confirmationModalOnClickClose(context, data) {
        page.redirect(data);
    }
}
